import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Redirige vers les pages d'erreur brandées lors des échecs d'API :
 *   - statut >= 500  → /500
 *   - statut 403     → /403
 *
 * Prudence : uniquement sur les requêtes GET (chargement de contenu). Les
 * POST (formulaires : plainte, signalement, paiement…) conservent leur
 * gestion d'erreur en ligne. Une requête peut désactiver la redirection via
 * l'en-tête `X-Skip-Error-Redirect` (fetch optionnel en arrière-plan).
 */
@Injectable()
export class ErrorRedirectInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const skip = req.headers.has('X-Skip-Error-Redirect');
        if (!skip && req.method === 'GET') {
          if (err.status >= 500) {
            this.router.navigateByUrl('/500');
          } else if (err.status === 403) {
            this.router.navigateByUrl('/403');
          }
        }
        return throwError(() => err);
      }),
    );
  }
}
